import { useAuth } from 'contexts/AuthContext'
import { useState, useEffect } from 'react'
import { GET } from 'api/request'
import * as urls from 'api/urls'

const usePinProfiles = (
  callback: base.BasicFunc
) => {
  const [data, setData] = useState<null | board.Board[]>(null)
  const [isLoading, setLoading] = useState(false)
  const { isAuth } = useAuth()

  const fetchDetails = async () => {
    setLoading(true)
    try {
      const response = await GET<board.BoardsListResponse>(urls.boardslist)
      if (response.ok) {
        const list = response.data.savedBoards['']
        if (Array.isArray(list) && list.length > 0) {
          setData(list)
        } else {
          callback()
        }
      } else {
        throw new Error('Wrong response')
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)
      console.error('Fetch failed: ', error)
    }
  }

  useEffect(() => {
    if (isAuth) fetchDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth])

  return {
    data,
    isLoading
  }
}

export default usePinProfiles